import styled from 'styled-components'
import { desktopVw } from '../../styles/utils'
import richTextRenderer from '../../utils/richTextRenderer'

import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

const MarketingContactSection = styled.div`
  margin: 60px 0 52px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin: ${desktopVw(39)} 0 0 0;
    padding: ${desktopVw(57)} ${desktopVw(100)};

    flex-direction: row;
  }
`

const MarketingContactSectionItem = styled.div`
  margin: 0;
  padding: 30px 0;
  background: ${props => props.background};
  border-bottom: 1px solid rgba(33, 32, 31, 0.2);
  display: flex;
  flex-direction: column;
  width: 193px;
  max-height: 183px;
  box-sizing: content-box;

  &:first-child {
    padding-top: 0px;
  }

  &:last-child {
    border-right: none;
    border-bottom: none;
  }

  h1 {
    text-align: center;
    font-family: ${props => props.theme.fonts.ivyText};
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 13px;
    text-transform: lowercase;
  }

  h1:first-letter {
    text-transform: uppercase;
  }

  a {
    text-decoration: underline;
  }

  p,
  a,
  button {
    text-align: center;
    font-family: ${props => props.theme.fonts.grosa};
    font-size: 13px;
    line-height: 19px;
  }

  p:not(:first-child):not(:last-child) {
    margin-bottom: 20px;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    padding: 0 ${desktopVw(30)};
    margin: 0;
    background: ${({ theme }) => theme.colors.secondary};
    border-right: 1px solid rgba(33, 32, 31, 0.2);
    border-bottom: none;
    width: ${desktopVw(200)};
    height: ${desktopVw(230)};
    max-height: unset;

    &:first-child {
      padding-left: 0px;
      padding-top: 0px;
    }

    &:last-child {
      padding-right: 0px;
    }

    h1 {
      font-size: ${desktopVw(24)};
      line-height: ${desktopVw(32)};
      margin-bottom: ${desktopVw(15)};
      margin-top: ${desktopVw(2)};
    }

    p,
    a,
    button {
      font-size: ${desktopVw(13)};
      line-height: ${desktopVw(19)};
    }
  }
`

const ChatButton = styled.button`
  cursor: pointer;
  text-decoration: underline;
`

const SECTION_TYPES = {
  CALL_US: 'CALL_US',
  EMAIL_US: 'EMAIL_US',
  CHAT_WITH_US: 'CHAT_WITH_US',
}
export const TRACKING_EVENT_BY_SECTION_TYPES = {
  [SECTION_TYPES.EMAIL_US]: TELEMETRY_EVENT_NAMES.MAIL_TO_US_CLICKED,
  [SECTION_TYPES.CALL_US]: TELEMETRY_EVENT_NAMES.PHONE_TO_US_CLICKED,
}

export function MarketingSection({ marketingTexts, onChat }) {
  return (
    <MarketingContactSection>
      {marketingTexts.map((textObj, index) => {
        const eventName = TRACKING_EVENT_BY_SECTION_TYPES[textObj.sectionType]

        if (textObj)
          return (
            <MarketingContactSectionItem key={textObj.id}>
              {richTextRenderer(
                textObj?.text?.json,
                eventName
                  ? getAddClickOnHyperRenderOption(() => {
                      trackEvent(eventName, {
                        placing: 'contact_us',
                      })
                    })
                  : undefined,
              )}
              {index === 0 && <ChatButton onClick={onChat}>Chat Now</ChatButton>}
            </MarketingContactSectionItem>
          )
      })}
    </MarketingContactSection>
  )
}

export const getAddClickOnHyperRenderOption = clickCallback => ({
  renderNode: {
    hyperlink: node => renderHyperLinkNode(clickCallback, node),
  },
})

const renderHyperLinkNode = (clickCallback, { content, data }) => {
  if ((data.uri.includes('mailto:') || data.uri.includes('tel:')) && isTextNode(content[0])) {
    return (
      <a
        href={data.uri}
        onClick={() => {
          clickCallback?.()
        }}
      >
        {content[0].value}
      </a>
    )
  }
  return isTextNode(content[0]) && <a href={data.uri}>{content[0].value}</a>
}

export const isTextNode = node => {
  if (node?.value) {
    return true
  }
  return false
}
